import { PageRef, RoutersDefinition } from '@wix/document-services-types';
import { PageRule } from '@wix/editor-platform-sdk-types';
import { RoutersDefinitionWithId } from '@wix/document-services-types/src/rendererModel';
import { getPageRoleByPageId } from './pages';
import { getRouterConfig } from './routers';

function getVariantsByPageRole(config: string, pageRole: string): string[] {
  const roleVariations = JSON.parse(config)?.roleVariations || {};
  const ruleIds = roleVariations[pageRole] || [];
  const allRules = JSON.parse(config)?.rules || {};
  return ruleIds.map((id: string) => allRules[id].pageRole);
}

function getVariant(
  config: string,
  pages: RoutersDefinition['pages'],
  pageRef: PageRef,
) {
  const role = getPageRoleByPageId(pages, pageRef.id);
  if (role && JSON.parse(config)?.rules) {
    const rules: PageRule[] = Object.values(JSON.parse(config).rules);
    return !!rules.find((rule: PageRule) => rule.pageRole === role);
  }
  return false;
}

function getVariantRuleId(
  routerData: RoutersDefinition | RoutersDefinitionWithId,
  variantPageRef: PageRef,
) {
  const pageRole = getPageRoleByPageId(routerData.pages, variantPageRef.id);

  const routerConfig = getRouterConfig(routerData);
  const rules: Record<string, PageRule> = routerConfig.rules;
  const ruleId = Object.keys(rules).find(
    (id: string) => rules[id].pageRole === pageRole,
  );
  if (!ruleId) {
    throw new Error(`pageId: '${variantPageRef.id}' does not contain a rule`);
  }
  return ruleId;
}

export { getVariantsByPageRole, getVariant, getVariantRuleId };
